export const generatePath = (path, wallet_id) => {
    return path.replace(':wallet_id', wallet_id);
};
